import { render, staticRenderFns } from "./BtnEditarExperiencia.vue?vue&type=template&id=4942fae4&"
import script from "./BtnEditarExperiencia.vue?vue&type=script&lang=js&"
export * from "./BtnEditarExperiencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports